import React from 'react';
import Authentication from '../components/authentication/Authentication';
import useLoginToken from '../hooks/useLoginToken';

export const LoginCheck = props => {
  const [token] = useLoginToken();
  if (token === null) return <Authentication />;
  return <>{props.children}</>;
};
